import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { EegUserDataLocation } from '@/lib/eeg/types/user-data';

export type EegDataState = {
  pod?: string;
  utility?: string;
  location?: EegUserDataLocation;
  iban?: string;
};

const useEegDataStore = create<EegDataState>()(
  devtools(() => ({
    pod: undefined,
    utility: undefined,
    location: undefined,
    iban: undefined,
  }))
);

export default useEegDataStore;
